import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsParameters from "../../../src/SubTabsParameters";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';


  export default class ParametersKitsContent extends Component{ 

    constructor(props){
      super(props);

      this.state={
        kitSearchTerm: '',
        isKitDropdownOpen: false,
          kitscontent:[],
          modalTitle:"",
          number_items:"",
          product: {
            productid:0,
            productdescription:"",
            sapcode:""
            },
          kit: {
            productid:0,
            duplicate:"",
            sapcodedup:""
            },
          kitcontentid:0,


          KitcontentIdFilter:"",
          KitIdFilter:"",
          KitDescriptionFilter:"",
          ProductIdFilter:"",
          ProductDescriptionFilter:"",
          kitscontentWithoutFilter:[],
          kitNames: [],
          SapcodeDupNames:[],
          SapcodeDupDescriptionNames:[],
          productNames: [] ,
          SapcodeNames:[],
          SapcodeDescriptionNames:[],
          isEditClicked: false,
          loading: true,
          currentKitIndex: 0,       
        
      }
  }

  FilterFn(){
    var KitcontentIdFilter=this.state.KitcontentIdFilter;
    var KitIdFilter=this.state.KitIdFilter;
    var KitDescriptionFilter = this.state.KitDescriptionFilter;
    var ProductIdFilter = this.state.ProductIdFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;

    var filteredData=this.state.kitscontentWithoutFilter.filter(
        function(el){
            return el.kitcontentid.toString().toLowerCase().includes(
                KitcontentIdFilter.toString().trim().toLowerCase()
            )&&
            el.kit?.sapcodedup.toString().toLowerCase().includes(
              KitIdFilter.toString().trim().toLowerCase()
            )&&
            el.kit?.duplicate.toString().toLowerCase().includes(
              KitDescriptionFilter.toString().trim().toLowerCase()
            )&&
            el.product?.sapcode.toString().toLowerCase().includes(
              ProductIdFilter.toString().trim().toLowerCase()
            )&&
            el.product?.productdescription.toString().toLowerCase().includes(
              ProductDescriptionFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({kitscontent:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.kitscontentWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({kitscontent:sortedData});

}

changeKitcontentIdFilter = (e)=>{
  this.state.KitcontentIdFilter=e.target.value;
  this.FilterFn();
}
changeKitIdFilter = (e)=>{
  this.state.KitIdFilter=e.target.value;
  this.FilterFn();
}

changeProductIdFilter = (e)=>{
  this.state.ProductIdFilter=e.target.value;
  this.FilterFn();
}

changeKitDescriptionFilter = (e)=>{
  this.state.KitDescriptionFilter=e.target.value;
  this.FilterFn();
}


changeProductDescriptionFilter = (e)=>{
  this.state.ProductDescriptionFilter=e.target.value;
  this.FilterFn();
}

refreshList = () => {
  axiosService.get('/kitscontent/')
    .then((response) => {
      const data = response.data?.results ?? response.data;
      this.setState({ kitscontent: data, kitscontentWithoutFilter: data, loading: false });
      // Get the number of results in kitscontent data
      const numberOfResults = data.length;
      console.log('Number of results:', numberOfResults);
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      this.setState({ loading: false });
    });
};

fetchKitNames() {
  axiosService.get('/defaultkits/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const kitNames = filteredData.map(item => item.productdescription)
                        .sort((a, b) => a.localeCompare(b));

      this.setState({ kitNames: kitNames });
    })
    .catch(error => {
      console.error("Error fetching kit names:", error);
    });
}

fetchSapcodeDupNames() {
  axiosService.get('/defaultkits/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeDupNames = filteredData.map(item => item.sapcodedup);

      const sapcodeToProductDescriptionMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcodedup] = item.productdescription;
      });

      this.setState({ SapcodeDupNames: SapcodeDupNames,SapcodeDupDescriptionNames:sapcodeToProductDescriptionMap  });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcodeDup(sapcodedup) {
  const productDescriptionMap = this.state.SapcodeDupDescriptionNames;
  return productDescriptionMap[sapcodedup] || "Kit not found";
}


fetchProductNames() {
  axiosService.get('/defaultitems/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const productNames = filteredData.map(item => item.productdescription);
      this.setState({ productNames: productNames });
    })
    .catch(error => {
      console.error("Error fetching product names:", error);
    });
}

fetchSapcodeNames() {
  axiosService.get('/defaultitems/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeNames = filteredData.map(item => item.sapcode);

      const sapcodeToProductDescriptionMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
      });

      this.setState({ SapcodeNames: SapcodeNames,SapcodeDescriptionNames:sapcodeToProductDescriptionMap  });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcode(sapcode) {
  const productDescriptionMap = this.state.SapcodeDescriptionNames;
  return productDescriptionMap[sapcode] || "Product not found";
}




handleScrollRight = () => {
  this.setState((prevState) => ({
    currentKitIndex: Math.min(prevState.currentKitIndex + 1, prevState.kitNames.length - 1),
  }));
};

handleScrollLeft = () => {
  this.setState((prevState) => ({
    currentKitIndex: Math.max(prevState.currentKitIndex - 1, 0),
  }));
};

componentDidMount(){
  this.refreshList();
  this.fetchKitNames();
  this.fetchProductNames();
  this.fetchSapcodeDupNames();
  this.fetchSapcodeNames();
}


changeKitDescription =(e)=>{
  this.setState({duplicate:e.target.value});
}


resetSelect = () => {
  setTimeout(() => {
    this.setState({ selectedKit: this.state.duplicate });
    this.setState({ selectedProduct: this.state.productdescription });
  }, 0);
};

addClick() {
  this.resetSelect();
  this.setState({
    modalTitle: "Add Product",
    kitcontentid: 0,
    productdescription:"",
    duplicate:"",
    productid: 0,
    isEditClicked: false,
  });
}


editClick(dep){
  this.resetSelect();
  this.setState({
      modalTitle:"Edit KitContent",
      kitcontentid:dep.kitcontentid,
      productdescription:dep.product.productdescription,
      duplicate:dep.kit.duplicate,
      productid:dep.product.productid,
      initialProductdescription:dep.product.productdescription,
      initialDuplicate:dep.kit.duplicate,
      isEditClicked: true,

  });
}

createClick() {
  const { productdescription, duplicate, number_items} = this.state;


  if (!productdescription) {
    alert('Product is required');
    return;
  }

  if (!duplicate) {
    alert('Kit is required');
    return;
  }

  // console.log({productdescription, duplicate})
  // return;

  axiosService.post('/kitscontentcreate/', {
    productdescription:productdescription,
    duplicate: duplicate,
    number_items: number_items
  })
    .then(result => {
      alert('Product added to kit  ');
      this.refreshList();
      
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {

  const {   productdescription, duplicate, initialProductdescription, initialDuplicate } = this.state;

   // Check if any changes are detected
   if (
    productdescription === initialProductdescription &&
    duplicate === initialDuplicate
  ) {
    alert('No changes detected');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  if (!duplicate) {
    alert('Kit is required');
    return;
  }


  axiosService.patch('/kitscontent/' + id + '/', {
    kitcontentid: this.state.kitcontentid,
    productdescription: this.state.productdescription,
    duplicate: this.state.duplicate
  })
    .then((result) => {
      alert('Update successful');
      this.refreshList();
    })
    .catch((error) => {
      alert('Failed');
    });
}


deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/kitscontent/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
      })
      .catch(error => {
        alert(error.message);
      });
  }
}


render(){
  const {
      kitscontent,
      modalTitle,
      productdescription,
      duplicate,
      sapcodedup,
      sapcode,
      kitcontentid,
      loading,
      kitNames,
      currentKitIndex
  }=this.state;


  return(
<div className="scrollable-container">
<MyPage />
<SubTabsParameters />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Build Kit
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeKitIdFilter}
      style={{ width: "100px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      Kit SAP Code / SKU
  </th>

  {/* <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
          <select
            className="form-select"
            value={this.state.duplicate}
            onChange={this.changeKitDescriptionFilter}
            style={{ width: "400px", height:"30px" ,fontSize: "12px"}}
          >
            <option value="">Select a kit</option>
            {this.state.kitNames.map((kit) => (
              <option key={kit} value={kit}>
                {kit}
              </option>
            ))}
          </select>
      </div>
      Kit
  </th> */}

<th style={{ fontSize: "12px", textAlign: "center" }}>
  <div className="d-flex flex-row align-items-center justify-content-center">
    <div style={{ position: 'relative', width: '400px' }}>
      <input
        type="text"
        className="form-control m-2"
        placeholder={this.state.duplicate || "Search kit..."}
        value={this.state.kitSearchTerm || ''}
        onChange={(e) => this.setState({ 
          kitSearchTerm: e.target.value,
          isKitDropdownOpen: true 
        })}
        onFocus={() => this.setState({ isKitDropdownOpen: true })}
        style={{ width: "400px", height: "30px", fontSize: "12px", paddingRight: "30px" }}
      />
      
      {this.state.duplicate && (
        <button
          onClick={() => {
            this.setState({ duplicate: '', kitSearchTerm: '' });
            this.changeKitDescriptionFilter({ target: { value: '' } });
          }}
          style={{
            position: 'absolute',
            right: '5px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            color: '#6c757d',
            padding: '0 5px',
            zIndex: 1001
          }}
          title="Clear filter"
        >
          ×
        </button>
      )}
      
      {this.state.isKitDropdownOpen && (
        <>
          <div 
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
            onClick={() => this.setState({ isKitDropdownOpen: false, kitSearchTerm: '' })}
          />
          <div style={{
            position: 'absolute', top: '100%', left: 0, right: 0,
            maxHeight: '200px', overflowY: 'auto', backgroundColor: 'white',
            border: '1px solid #ced4da', borderTop: 'none',
            borderRadius: '0 0 4px 4px', zIndex: 1000,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            {this.state.kitNames
              .filter(k => k.toLowerCase().includes((this.state.kitSearchTerm || '').toLowerCase()))
              .map((kit) => (
                <div
                  key={kit}
                  onClick={() => {
                    this.setState({ duplicate: kit, isKitDropdownOpen: false, kitSearchTerm: '' });
                    this.changeKitDescriptionFilter({ target: { value: kit } });
                  }}
                  style={{
                    padding: '8px 12px', cursor: 'pointer', fontSize: '12px',
                    fontWeight: 'normal',
                    backgroundColor: this.state.duplicate === kit ? '#e9ecef' : 'white',
                    borderBottom: '1px solid #f0f0f0'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = this.state.duplicate === kit ? '#e9ecef' : 'white';
                  }}
                >
                  {kit}
                </div>
            ))}
          </div>
        </>
      )}
    </div>
  </div>
  Kit
</th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeProductIdFilter}
      style={{ width: "100px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>
      </div>
      Product SAP Code / SKU
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
          <select
            className="form-select"
            value={this.state.productdescription}
            onChange={this.changeProductDescriptionFilter}
            style={{ width: "400px", height:"30px" ,fontSize: "12px"}}
          >
            <option value="">Select a product</option>
            {this.state.productNames.map((product) => (
              <option key={product} value={product}>
                {product}
              </option>
            ))}
          </select>
      </div>
      Product
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
   {/* <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeProductIdFilter}
      style={{ width: "100px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>
      </div> */}
     Number items
  </th>



  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {kitscontent.map(dep=>
      <tr key={dep.kitcontentid} className="row-hover">
          <td className="table-text">{dep.kit.sapcodedup}</td>
          <td className="table-text">{dep.kit.duplicate}</td>
          <td className="table-text">{dep.product.sapcode}</td>
          <td className="table-text">{dep.product.productdescription}</td>
          <td className="table-text">{dep.number_items}</td>
          <td className="table-text">
          <div style={{ display: "flex", justifyContent: "center" }}>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.kitcontentid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </div>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
    
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit</span>
  <select
    className="form-select"
    value={this.state.sapcodedup}
    onChange={(event) => {
      const selectedSapcodedup = event.target.value;
      this.setState({ sapcodedup: selectedSapcodedup });
      // Automatically find and set the corresponding productdescription
      const duplicate = this.findProductDescriptionForSapcodeDup(selectedSapcodedup);
      this.setState({ duplicate: duplicate });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select kit SAPCODE</option>
    {this.state.SapcodeDupNames.map((sapcodedup) => (
      <option key={sapcodedup} value={sapcodedup}>
        {sapcodedup}
      </option>
    ))}
  </select>
</div>

<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.duplicate} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ duplicate: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>


    
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>

<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Number items</span>
  <input
    type="number"
    className="form-control"
    value={this.state.number_items} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ number_items: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
  />
</div>




        {kitcontentid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Add Item
          </button>
        ) : null}

        {kitcontentid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(kitcontentid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
}

